import { Box } from "@mui/material";

import { speedLogo } from "../images";
import "../../assets/auth.scss";

const CommonAuthHeader = ({ children, showSpeedLogo = true, sx = null }) => {
  return (
    <Box className="options-container">
      <Box
        className="auth-wrapper"
        sx={showSpeedLogo && { justifyContent: "center !important" }}
      >
        {showSpeedLogo && (
          <Box display="flex" alignItems="center" mb="40px">
            <img src={speedLogo} alt="speed-logo" height={36} width={128} />
          </Box>
        )}
        <Box className="auth-container" position="relative" sx={sx}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default CommonAuthHeader;
